import type { CobranzaFilters } from '../../modelos/cobranzas/cobranzas.types';
import { getStartOfYearISODate, getEndOfYearISODate } from '@/shared/time/businessTime';

export const DEFAULT_COBRANZA_FILTERS: CobranzaFilters = {
  rangoFechas: {
    from: getStartOfYearISODate(),
    to: getEndOfYearISODate(),
  },
  cliente: '',
  estado: 'todos',
  formaPago: 'todos',
  formaPagoCuenta: 'todos',
  medioPagos: [],
  establecimientoId: 'todos',
  cajeroId: 'todos',
};
